import React, { useState } from "react";
import { RelevantTenantInfo } from "routes/Admin/Accounts/Members/Helpers";
import { DeviceUserGroupListView } from "./DeviceUserGroupListView";
import { UserGroup, useListUserGroupsForTenantQuery } from "generated/graphql";
import { needs, useGuard } from "rbac";

export const DeviceUserGroupList: React.FC<{
  tenant: RelevantTenantInfo;
}> = ({ tenant }) => {
  const [selectedItems, setSelectedItems] = useState<Array<string>>([]);
  const userCanEdit = useGuard(needs("delete:usergroup"));
  const { data, fetching } = useListUserGroupsForTenantQuery({
    variables: { tenantId: tenant.id }
  });

  const userGroups: Array<Omit<UserGroup, "users" | "policies"> & {
    user_count: number;
  } & { policies: Array<{ id: string; priority: string }> }> =
    data?.userGroupsForTenant?.map(({ users, ...rest }) => ({
      ...rest,
      policies: rest.policies ?? [],
      user_count: users.length
    })) ?? [];

  return (
    <DeviceUserGroupListView
      userGroups={userGroups}
      userCanEdit={userCanEdit}
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      loading={fetching}
      tenantId={tenant.id}
    />
  );
};

export default DeviceUserGroupList;
